import app from './app';
import { saveAs } from 'file-saver';
import { ORDER_SERVICE_URL } from '../../libs/constants';

const getDirectCustomerPayments = (searchConfig, userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    let url = ORDER_SERVICE_URL + "/financialData/" + userId;
    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getDirectCustomerPayments"
        }
    };

    await api.post(url, searchConfig, headerConfig)
        .then(response => {
            if (response.data) {
                dispatch({
                    type: "SET_DIRECT_CUSTOMER_PAYMENTS_LIST",
                    payload: response.data
                });
            }
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            console.log(error);
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const updateFinancialData = (value, columnName, rowIndex) => {
    return {
        type: 'UPDATE_DIRECT_CUSTOMER_PAYMENTS_LIST',
        value,
        columnName,
        rowIndex
    }
};

const actions = {
    getDirectCustomerPayments,
    updateFinancialData
}

export default actions;